@use "../../styles/breakpoint.module.scss" as *;

.form {
    display: flex;

    :global(.react-aria-TextField) {
        flex-grow: 1;

        input[type="search"] {
            width: 100%;
        }
    }
}

.submit {
    [data-design-version="v2024"] & {
        --height: 44px;

        @media ($below-mobile) {
            --height: 41px;
        }
    }
}

.svg {
    scale: 1.5;
}
